import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: () => import('../views/HomeView'),
  },
  {
    path: '/lb',
    name: 'lb',
    component: () => import('../views/lb'),
  },
  {
    path: '/home2',
    name: 'home2',
    component: () => import('../views/HomeView2'),
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../views/test'),
  },
  {
    path: '/gdt',
    name: 'gdt',
    component: () => import('../components/Gdt'),
  },
  {
    path: '/myfoot',
    name: 'myfoot',
    component: () => import('../components/MyFoot'),
  },
  {
    path: '/meeting',
    name: 'meeting',
    component: () => import('../views/Meeting'),
  },
  {
    path: '/exibitions',
    name: 'exibitions',
    component: () => import('../views/Exibitions'),
  },
  {
    path: '/whysponsor',
    name: 'whysponsor',
    component: () => import('../views/Whysponsor'),
  },
  {
    path: '/hyticket',
    name: 'hyticket',
    component: () => import('../views/Hyticket'),
  },
  {
    path: '/freeticket',
    name: 'freeticket',
    component: () => import('../views/Freeticket'),
  },
  // {
  //   path: '/awards',
  //   name: 'awards',
  //   component: () => import('../views/Awards'),
  // },
  {
    path: '/tabm',
    name: 'tabm',
    component: () => import("../views/TabBm"),
  },
  {
    path: '/agenda',
    name: 'agenda',
    component: () => import("../views/Aggenda"),
  },


]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  window.scrollTo(0, 0);
  next();
})
export default router
